import request from "../utils/request";
import setting from "./apiSetting";
var type = "GroupRole";
var urls = 'http://' + setting.getip() + ":" + setting.getport() + "/api/" + type;
var myfunction = {
  //根据groupid获取权限列表
  GetByGroupId: function GetByGroupId(groupid) {
    var params = {
      groupid: groupid
    };
    return request({
      url: urls + "/GetByGroupId",
      method: 'get',
      params: params
    });
  },
  deleteGroupRole: function deleteGroupRole(data) {
    return request({
      url: urls + '/DeleteByGroupId',
      method: 'get',
      params: data
    });
  },
  addOrUpdateGroupRole: function addOrUpdateGroupRole(params, data) {
    return request({
      url: urls + '/AddOrUpdate',
      method: 'post',
      params: params,
      data: data
    });
  }
};
export default myfunction;